interface Props {
  [key: string]: any
}

function PhoneGradientSupportIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 13 13" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M0.779057 2.60262C0.779057 2.27943 0.907443 1.96948 1.13597 1.74095C1.3645 1.51242 1.67445 1.38403 1.99764 1.38403H3.99612C4.12395 1.38413 4.2485 1.42443 4.35216 1.49922C4.45582 1.57401 4.53334 1.67951 4.57373 1.80079L5.48645 4.53834C5.5327 4.67746 5.52723 4.8286 5.47104 4.96402C5.41486 5.09944 5.31174 5.21006 5.18058 5.27558L3.80541 5.96408C4.47948 7.45596 5.67439 8.65087 7.16627 9.32494L7.85477 7.94977C7.9203 7.81862 8.03091 7.71549 8.16633 7.65931C8.30175 7.60313 8.45289 7.59766 8.59201 7.6439L11.3296 8.55662C11.4509 8.59705 11.5565 8.67465 11.6313 8.77843C11.7061 8.88222 11.7463 9.00691 11.7463 9.13484V11.1327C11.7463 11.4559 11.6179 11.7659 11.3894 11.9944C11.1609 12.2229 10.8509 12.3513 10.5277 12.3513H9.91844C4.87106 12.3513 0.779057 8.25929 0.779057 3.21191V2.60262Z"
        stroke="url(#linear_phone_support)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.860178"
      />
      <defs className={pathClassName ? `stroke-current ${pathClassName}` : ''}>
        <linearGradient gradientTransform="rotate(21.67)" id="linear_phone_support">
          <stop offset="25.12%" stopColor="#7D38D6" />
          <stop offset="100%" stopColor="#58C1FC" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default PhoneGradientSupportIcon
